var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.733,
    cy: 19.4502,
    r: 18.75,
    fill: "#FDFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2857 8.70468L22.4686 8.7002C19.3037 8.7002 17.2584 10.783 17.2584 14.0066V16.4532H14.426C14.1812 16.4532 13.983 16.6501 13.983 16.8931V20.4379C13.983 20.6808 14.1815 20.8775 14.426 20.8775H17.2584V29.8223C17.2584 30.0652 17.4566 30.262 17.7014 30.262H21.3969C21.6417 30.262 21.8399 30.065 21.8399 29.8223V20.8775H25.1517C25.3964 20.8775 25.5946 20.6808 25.5946 20.4379L25.596 16.8931C25.596 16.7764 25.5492 16.6647 25.4663 16.5822C25.3833 16.4996 25.2703 16.4532 25.1528 16.4532H21.8399V14.3792C21.8399 13.3823 22.0792 12.8763 23.3875 12.8763L25.2852 12.8756C25.5298 12.8756 25.728 12.6786 25.728 12.4359V9.14434C25.728 8.90185 25.53 8.70513 25.2857 8.70468Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cecff280dc1d935417ef1e7f95e2e02b.svg";
export { ForwardRef as ReactComponent };